import React from "react";
import { Helmet } from "react-helmet";

const SchemaMarkupComponent = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://www.techecosolution.in/#organization",
        "name": "Techecosolution",
        "alternateName": ["TES", "Techeco Solution", "Techeco", "Techecosolution India"],
        "url": "https://www.techecosolution.in/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.techecosolution.in/logo192.png",
          "width": 192,
          "height": 192,
          "caption": "Techecosolution Logo"
        },
        "image": {
          "@type": "ImageObject",
          "url": "https://www.techecosolution.in/logo512.png",
          "width": 512,
          "height": 512
        },
        "description": "Techecosolution (TES) provides comprehensive IT services including Web Development, UI/UX Designing, Digital Marketing, and SEO Services to help businesses grow online.",
        "email": "mailto:techecosolution@gmail.com",
        "telephone": "+91-9483085077",
        "foundingDate": "2020",
        "founder": {
          "@type": "Person",
          "name": "Techecosolution Founder"
        },
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "minValue": 10,
          "maxValue": 50
        },
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Bangalore",
          "addressLocality": "Bangalore",
          "addressRegion": "Karnataka",
          "postalCode": "560001",
          "addressCountry": "IN"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 12.9716,
          "longitude": 77.5946
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+91-9483085077",
          "contactType": "customer service",
          "areaServed": "IN",
          "availableLanguage": ["English", "Hindi", "Kannada"]
        },
        "sameAs": [
          "https://www.facebook.com/techecosolution",
          "https://www.instagram.com/techecosolution",
          "https://www.linkedin.com/company/techecosolution",
          "https://twitter.com/techecosolution"
        ],
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "150",
          "bestRating": "5",
          "worstRating": "1"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "IT Services Catalog",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Web Development",
                "description": "Professional responsive website development services using modern technologies",
                "serviceType": "Technology Services",
                "provider": {
                  "@id": "https://www.techecosolution.in/#organization"
                }
              }
            },
            {
              "@type": "Offer", 
              "itemOffered": {
                "@type": "Service",
                "name": "UI/UX Design",
                "description": "Creative and user-focused UI/UX design services for websites and applications",
                "serviceType": "Design Services",
                "provider": {
                  "@id": "https://www.techecosolution.in/#organization"
                }
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Digital Marketing",
                "description": "Comprehensive digital marketing and SEO services to boost online presence",
                "serviceType": "Marketing Services",
                "provider": {
                  "@id": "https://www.techecosolution.in/#organization"
                }
              }
            }
          ]
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://www.techecosolution.in/#website",
        "url": "https://www.techecosolution.in/",
        "name": "Techecosolution",
        "alternateName": "TES",
        "description": "Techecosolution provides comprehensive IT services including Web Development, UI/UX Design, Digital Marketing, and SEO Services.",
        "publisher": {
          "@id": "https://www.techecosolution.in/#organization"
        },
        "inLanguage": "en-US",
        "potentialAction": {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": "https://www.techecosolution.in/search?q={search_term_string}"
          },
          "query-input": "required name=search_term_string"
        }
      }
    ]
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
        
        {/* Favicon Configuration for Search Engines */}
        <link rel="icon" type="image/x-icon" href="/favicon.ico" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="192x192" href="/logo192.png" />
        <link rel="icon" type="image/png" sizes="512x512" href="/logo512.png" />
        
        {/* Additional Meta for Brand Recognition */}
        <meta name="application-name" content="Techecosolution" />
        <meta name="apple-mobile-web-app-title" content="Techecosolution" />
        <meta name="msapplication-TileColor" content="#0e5cae" />
        <meta name="theme-color" content="#0e5cae" />
        
        {/* SEO Meta Tags */}
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <meta name="googlebot" content="index, follow" />
        <meta name="bingbot" content="index, follow" />
        
        {/* Brand Keywords for Better Search Recognition */}
        <meta name="keywords" content="Techecosolution, TES, Techeco Solution, Techeco, web development India, digital marketing Bangalore, SEO services India, software development India, mobile app development India, IT services India, tech solutions India" />
      </Helmet>
    </>
  );
};

export default SchemaMarkupComponent;